<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="4">
					<!-- 품번 -->
					<search-input
						:label="getMessage_('QWCC000956')"
						paramKey="searchPartNo"
						@commInput="setSearchParam"
						@keyup.native.delete="() => onPartNoInPutKeyDown('pprNo')"
						:clearable="false"
						:propData="searchPopupParams.partNo"
					>
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPprPopup"></i></template>
					</search-input>
				</el-col>
				<el-col :span="4">
					<!-- ppr번호 -->
					<search-input
						:label="getMessage_('QWCC001034')"
						paramKey="pprNo"
						@commInput="setSearchParam"
						:clearable="true"
						:propData="searchPopupParams.pprNo"
						:readonly="true"
					>
					</search-input>
				</el-col>
			</el-row>
			<template slot="button">
				<!-- 조회 -->
				<sf-button line icon="search" :onClick="searchPprInfo" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
		<!-- 팝업정보 시작 -->
		<part-mng-popup ref="partMngPopup" @SendData="sendData" :scrId="scrId" />
		<ppr-no-popup
			ref="pprNoPopup"
			@PprSendData="pprSendData"
			:scrId="scrId"
			:flgOsGrp="this.flgOsGrp"
			:flgPqyapGrp="this.flgPqyapGrp"
			:flgPqyrvGrp="this.flgPqyrvGrp"
			:flgPqyrgGrp="this.flgPqyrgGrp"
			:flgPqycpGrp="this.flgPqycpGrp"
		/>
		<!-- <ppr-no-popup ref="pprNoPopup" @SendData="sendData" :scrId="scrId" /> -->
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PrtRpt/store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import PprNoPopup from '@qms/pqy/pcku/PrtRpt/Content/Popup/PprNoPopup/PprNoPopup.vue';
import PartMngPopup from '@qms/comm/commpopup/PartMngPopup/PartMngPopup.vue';

export default {
	props: {
		scrId: { type: String, default: '' },
		flgOsGrp: { type: Boolean, default: false }, // 시스템 관리자
		flgPqyapGrp: { type: Boolean, default: false }, //승인자
		flgPqyrvGrp: { type: Boolean, default: false }, //검토자
		flgPqyrgGrp: { type: Boolean, default: false }, //작성자
		flgPqycpGrp: { type: Boolean, default: false } //외부협력사
	},
	data() {
		return { searchDateRange: [] };
	},
	components: { SearchInput, PartMngPopup, PprNoPopup },
	methods: {
		...rootMethods,
		...serviceMethods,
		setSearchParam(param) {
			this.setSearchPopupParam_(param);
		},
		onPartNoInPutKeyDown(key) {
			this.setSearchPopupParam_({ key: key, value: '' });
		},
		onPartPopup() {
			this.$refs.partMngPopup.open(this.detailForm.searchPartNo);
		},
		//불량보고 번호조회 팝업 오픈
		onPprPopup() {
			this.$refs.pprNoPopup.open(this.searchParams.partNo);
		},
		async searchPprInfo() {
			const params = {
				pprNo: this.searchPopupParams.pprNo,
				partNo: this.searchPopupParams.partNo
			};
			try {
				this.$sf_toggleLoading(true);
				//await this.getOne_();
				await this.getPrtRptInfo_(params)
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.header.message
						});
						Promise.reject(error);
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
				const partGCd = await this.detailForm.partGCd;
				if (partGCd === 'K') {
					this.isGlims = true;
				} else {
					this.isGlims = false;
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		sendData(param) {
			// const langCd = this.langCd || navigator.language;
			// const partNm = (() => {
			// 	if (langCd === 'en_US') {
			// 		return param.enPartNm;
			// 	} else if (langCd === 'zh_CH') {
			// 		return param.chPartNm;
			// 	}
			// 	return param.koPartNm;
			// })();
			// this.onChangeParam_({ key: 'searchPartNo', value: param.partNo });
			// if (!this.detailForm.altrNo) {
			// 	this.onChangeParam_({ key: 'partNm', value: partNm });
			// 	this.onChangeParam_({ key: 'partNo', value: param.partNo });
			// }
		},
		pprSendData(row) {
			// console.log('popupSearch >>>>>', row, row.partNo, row.partNm, row.pprNo);
			this.setSearchPopupParam_({ key: 'pprNo', value: row.pprNo });
			this.setSearchPopupParam_({ key: 'partNo', value: row.partNo });
			//this.onChangeParam_({ key: 'partNm', value: row.partNm });
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
